import React, { useEffect, useState } from 'react';
import { Dialog, Grid, Box, Typography, Button } from '@mui/material';
import FormInputText from '../../../common/Forms/FormTextField';
import { useForm, useWatch } from 'react-hook-form';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import {
  EPISODE_ACTIVITIES_UPDATE_URL,
  ACTIVITY_DELETE_URL,
  fieldRequired,
  formDateFormat,
  stopYesNoOptions,
} from '../../../../constants';
import FormInputDropdown from '../../../common/Forms/FormDropdown';
import {
  setActId,
  setActivityByWestCareEmployee,
  setActivityType,
  setActivityWithContactName,
  setActivityWithContactType,
  setDateCompleted,
  setDateEarly,
  setDateLate,
  setIs12StepQuestionAnswered,
  setIs12StepQuestionAsked,
  setPriority,
  setRecdCBPROI,
  setActivityNote
} from '../../../../redux/episode/activitiesTab/episodeActivity/episodeActivitySlice';
import { postStopApi, setStopApi, deleteStopApi } from '../../../../services/StopApi/StopApi';
import FormSuccess from '../../../common/Forms/FormSuccess';
import { setRefreshEpisodeParticipant } from '../../../../redux/episode/episodeParticipant/episodeParticipantSlice';
import {
  DialogHeader,
  DialogHeading,
  ButtonWrapper,
  CancelButton,
  DeleteButton,
  SaveButton,
} from '../../Episode.Styled';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import EpisodeHeader from '../EpisodeHeader'
// import _ from 'lodash';

const schema = yup.object().shape({
  dateCompleted: yup.date().typeError(fieldRequired).required(),
  //dateEarly: yup.date().typeError(fieldRequired).required(),
  //dateLate: yup.date().typeError(fieldRequired).required(),
  activityType: yup.string().required(fieldRequired),
  //activityWithContactType: yup.string().required(fieldRequired),
  //activityWithContactName: yup.string().required(fieldRequired),
  activityByWestCareEmployee: yup.string().required(fieldRequired),
  //priority: yup.string().required(fieldRequired),
  //Is12StepQuestionAsked: yup.string().required(fieldRequired),
  //Is12StepQuestionAnswered: yup.string().required(fieldRequired),
  //recdCBPROI: yup.string().required(fieldRequired),
});

const ActivityDialog = (props) => {
  const { open, setOpen, authToken, episodeId, fetchData, networkUserName, episodeHeaderData } = props;
  const [formSuccess, setFormSuccess] = useState(false);
  const [isNewActivity, setIsNewActivity] = useState(false);
  const dispatch = useDispatch();
  const todayDate = new Date();
  todayDate.setDate(todayDate.getDate() + 29);
  const dateString = todayDate.toISOString().split('T')[0];
  const activitiesInfo = useSelector(
    (state) => state.episodeActivity?.activitiesDetail
  );
  //console.log(activitiesInfo)
  const activitiesRefernceData = useSelector(
    (state) => state?.activitiesRefernceData
  );
  const defaultValue = {
    actId: activitiesInfo?.actId,
    dateCompleted: moment(activitiesInfo?.dateCompleted).format(formDateFormat),
    dateEarly: moment(activitiesInfo.dateEarly).format(formDateFormat),
    dateLate: moment(activitiesInfo.dateLate).format(formDateFormat),
    activityType: activitiesInfo?.activityType?.value,
    activityWithContactType: activitiesInfo?.activityWithContactType?.value,
    activityWithContactName: activitiesInfo?.activityWithContactName?.value,
    activityByWestCareEmployee:
      activitiesInfo?.activityByWestCareEmployee?.value,
    priority: activitiesInfo?.priority?.value,
    Is12StepQuestionAsked: activitiesInfo?.Is12StepQuestionAsked,
    Is12StepQuestionAnswered:
      activitiesInfo?.Is12StepQuestionAsked === false
        ? false
        : activitiesInfo?.Is12StepQuestionAnswered,
    recdCBPROI: activitiesInfo?.recdCBPROI,
    activityNote: activitiesInfo?.activityNote
  };
  const useFunction = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
    resolver: yupResolver(schema),
  });
  const { handleSubmit, reset, control, setValue, watch, register, formState } =
    useFunction;

  let { isValid, dirtyFields, errors } = formState;
  // let activityError = errors;
  // switch (activitiesInfo?.activityType?.id) {
  //   case 2:
  //     errors.activityWithContactName = false;
  //     break;
  //   case 5:
  //     errors.activityWithContactName = false;
  //     break;
  // }

  useEffect(() => {
    reset(defaultValue);
  }, [
    defaultValue.activityNote,
    defaultValue.actId,
    defaultValue.dateCompleted,
    defaultValue.dateEarly,
    defaultValue.dateLate,
    defaultValue.activityType,
    defaultValue.activityWithContactType,
    defaultValue.activityWithContactName,
    defaultValue.activityByWestCareEmployee,
    defaultValue.priority,
    defaultValue.Is12StepQuestionAsked,
    defaultValue.Is12StepQuestionAnswered,
    defaultValue.recdCBPROI,
  ]);

  const activityNote = useWatch({
    control,
    name: 'activityNote',
  });

  const activityType = useWatch({
    control,
    name: 'activityType',
  });

  const activityTypeIds = activitiesRefernceData?.activityTypes?.filter(
    (item) => (item.value === activityType ? item.id : '')
  );
  const activityTypeValues = {
    id: activityTypeIds[0]?.id,
    value: activityTypeIds[0]?.value,
  };

  const activityWithContactType = useWatch({
    control,
    name: 'activityWithContactType',
  });

  const activityWithContactTypeIds =
    activitiesRefernceData?.contactTypes?.filter((item) =>
      item.value === activityWithContactType ? item.id : ''
    );
  const activityWithContactTypeValues = {
    id: activityWithContactTypeIds[0]?.id,
    value: activityWithContactTypeIds[0]?.value,
  };

  const activityWithContactName = useWatch({
    control,
    name: 'activityWithContactName',
  });

  const activityWithContactNameIds =
    activitiesRefernceData?.activityWithList?.filter((item) =>
      item.value === activityWithContactName ? item.id : ''
    );
  const activityWithContactNameValues = {
    id: activityWithContactNameIds[0]?.id,
    value: activityWithContactNameIds[0]?.value,
  };

  const activityByWestCareEmployee = useWatch({
    control,
    name: 'activityByWestCareEmployee',
  });

  const activityByWestCareEmployeeIds =
    activitiesRefernceData?.activityByList?.filter((item) =>
      item.value === activityByWestCareEmployee ? item.id : ''
    );
  const activityByWestCareEmployeeValues = {
    id: activityByWestCareEmployeeIds[0]?.id,
    value: activityByWestCareEmployeeIds[0]?.value,
  };

  const priority = useWatch({
    control,
    name: 'priority',
  });

  const priorityIds = activitiesRefernceData?.priorities?.filter((item) =>
    item.value === priority ? item.id : ''
  );
  const priorityValues = {
    id: priorityIds[0]?.id,
    value: priorityIds[0]?.value,
  };

  const Is12StepQuestionAsked = useWatch({
    control,
    name: 'Is12StepQuestionAsked',
  });

  const Is12StepQuestionAnswered = useWatch({
    control,
    name: 'Is12StepQuestionAnswered',
  });

  const recdCBPROI = useWatch({
    control,
    name: 'recdCBPROI',
  });

  useEffect(() => {
    dispatch(setActivityNote(activityNote));
    dispatch(setActivityType(activityTypeValues));
    dispatch(setActivityWithContactType(activityWithContactTypeValues));
    dispatch(setActivityWithContactName(activityWithContactNameValues));
    dispatch(setActivityByWestCareEmployee(activityByWestCareEmployeeValues));
    dispatch(setPriority(priorityValues));
    dispatch(setIs12StepQuestionAsked(Is12StepQuestionAsked));
    dispatch(setIs12StepQuestionAnswered(Is12StepQuestionAnswered));
    dispatch(setRecdCBPROI(recdCBPROI));
  }, [
    activityNote,
    activityType,
    activityWithContactType,
    activityWithContactName,
    activityByWestCareEmployee,
    priority,
    Is12StepQuestionAsked,
    Is12StepQuestionAnswered,
    recdCBPROI,
  ]);

  const handleClose = () => {
    setOpen(false);
    reset(defaultValue);
  };

  const handleDelete = () => {
    const actId = activitiesInfo?.actId;
    const url = `${ACTIVITY_DELETE_URL}/${actId}`;
    const authorization = authToken;
    const payload = {};
    deleteStopApi({ url, payload, authorization }).then((response) => {
      if (response.succeeded === true) {
        fetchData();
        handleClose();
      }
    }).catch((e) => alert(e));
  };

  const onSubmit = () => {
    const url = `${EPISODE_ACTIVITIES_UPDATE_URL}/${episodeId}/activities`;
    const payload = {
      actId: activitiesInfo?.actId,
      dateCompleted:
        activitiesInfo?.dateCompleted === '-'
          ? null
          : moment(activitiesInfo?.dateCompleted).format(formDateFormat),
      dateEarly:
        activitiesInfo.dateEarly === '-'
          ? null
          : moment(activitiesInfo.dateEarly).format(formDateFormat),
      dateLate:
        activitiesInfo.dateLate === '-'
          ? null
          : moment(activitiesInfo.dateLate).format(formDateFormat),
      activityType: activitiesInfo?.activityType?.id,
      activityByWestCareEmployee:
        activitiesInfo?.activityByWestCareEmployee?.id,
      activityWithContactName: activitiesInfo?.activityWithContactName?.id,
      activityWithContactType: activitiesInfo?.activityWithContactType?.id,
      unitQty: null,
      priority: activitiesInfo?.priority?.id,
      Is12StepQuestionAsked: activitiesInfo?.Is12StepQuestionAsked,
      Is12StepQuestionAnswered: activitiesInfo?.Is12StepQuestionAnswered,
      recdCBPROI: activitiesInfo?.recdCBPROI,
      actNote: activitiesInfo?.activityNote ? activitiesInfo?.activityNote + ' [' + networkUserName + ']' : '' 
    };
    const authorization = authToken;
    if (activitiesInfo?.newActivity) {
      const payload = {
        dateCompleted:
          activitiesInfo?.dateCompleted === ''
            ? null
            : moment(activitiesInfo?.dateCompleted).format(formDateFormat),
        dateEarly:
          activitiesInfo.dateEarly === ''
            ? null
            : moment(activitiesInfo.dateEarly).format(formDateFormat),
        dateLate:
          activitiesInfo.dateLate === ''
            ? null
            : moment(activitiesInfo.dateLate).format(formDateFormat),
        activityType: activitiesInfo?.activityType?.id,
        activityByWestCareEmployee:
          activitiesInfo?.activityByWestCareEmployee?.id,
        activityWithContactName: activitiesInfo?.activityWithContactName?.id,
        activityWithContactType: activitiesInfo?.activityWithContactType?.id,
        unitQty: null,
        priority: activitiesInfo?.priority?.id,
        Is12StepQuestionAsked:
          activitiesInfo?.Is12StepQuestionAsked === ''
            ? null
            : activitiesInfo?.Is12StepQuestionAsked,
        Is12StepQuestionAnswered:
          activitiesInfo?.Is12StepQuestionAnswered === ''
            ? null
            : activitiesInfo?.Is12StepQuestionAnswered,
        recdCBPROI:
          activitiesInfo?.recdCBPROI === '' ? null : activitiesInfo?.recdCBPROI,
        actNote:
          activitiesInfo?.activityNote ? activitiesInfo?.activityNote + ' [' + networkUserName + ']' : ''
      };
      postStopApi({ url, payload, authorization }).then((response) => {
        if (response.succeeded === true) {
          fetchData();
          setFormSuccess(true);
          setIsNewActivity(true);
          dispatch(setRefreshEpisodeParticipant(true));
          setTimeout(() => {
            dispatch(setRefreshEpisodeParticipant(false));
          }, 1000);
        }
      }).catch((e) => alert(e));
    } else {
      setStopApi({ url, payload, authorization }).then((response) => {
        if (response.succeeded === true) {
          fetchData();
          setFormSuccess(true);
          setIsNewActivity(false);
          dispatch(setRefreshEpisodeParticipant(true));
          setTimeout(() => {
            dispatch(setRefreshEpisodeParticipant(false));
          }, 1000);
        }
      }).catch((e) => alert(e));
    }
    setOpen(false);
  };

  return (
    <>
      <Dialog
        open={open}
        PaperProps={{
          sx: { maxWidth: 'unset', width: '1000px', maxHeight: 'unset' },
        }}
      >
        <DialogHeader>          
          <Grid container style={{ padding: '5px'}}>
            <EpisodeHeader data={episodeHeaderData} />
            <Grid item xs={6}>
              <DialogHeading variant='h5'>Activity Detail</DialogHeading>
            </Grid>
            <Grid item xs={6}>  
              <Grid container justifyContent="flex-end">
                <IconButton onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
              </Grid>
            </Grid>  
          </Grid>    
        </DialogHeader>
        <Grid container spacing={2} style={{ padding: '10px 40px' }}>
          <Grid item xs={12} sm={6}>
            {/* <FormInputText
                  name='actId'
                  control={control}
                  type='text'
                  label='Activity Key'
                  register={register('actId', {
                     onBlur: (e) => dispatch(setActId(e.target.value))
                  })}
               /> */}
            <FormInputText
              name='dateCompleted'
              control={control}
              type='date'
              label='Completed'
              maxValue={dateString}
              shrink={true}
              errors={!!errors.dateCompleted}
              helperText={errors?.dateCompleted?.message}
              register={register('dateCompleted', {
                onBlur: (e) => dispatch(setDateCompleted(e.target.value)),
              })}
            />
            <FormInputText
              name='dateEarly'
              control={control}
              type='date'
              label='Early'
              shrink={true}
              maxValue={defaultValue?.dateLate}
              errors={!!errors.dateEarly}
              helperText={errors?.dateEarly?.message}
              register={register('dateEarly', {
                onBlur: (e) => dispatch(setDateEarly(e.target.value)),
              })}
            />
            <FormInputText
              name='dateLate'
              control={control}
              type='date'
              label='Late'
              shrink={true}
              minValue={defaultValue?.dateEarly}
              errors={!!errors.dateLate}
              helperText={errors?.dateLate?.message}
              register={register('dateLate', {
                onBlur: (e) => dispatch(setDateLate(e.target.value)),
              })}
            />
            <FormInputDropdown
              name='activityType'
              control={control}
              type='text'
              options={activitiesRefernceData?.activityTypes}
              label='Activity Type'
              errors={!!errors.activityType}
              helperText={errors?.activityType?.message}
            />
            <FormInputDropdown
              name='activityWithContactType'
              control={control}
              label='Activity With Contact Type'
              options={activitiesRefernceData?.contactTypes}
              errors={!!errors.activityWithContactType}
              helperText={errors?.activityWithContactType?.message}
            />
            <FormInputDropdown
              name='activityWithContactName'
              control={control}
              label='Activity With Contact Name'
              options={activitiesRefernceData?.activityWithList}
              errors={!!errors.activityWithContactName}
              helperText={errors?.activityWithContactName?.message}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormInputDropdown
              name='activityByWestCareEmployee'
              control={control}
              label='Activity By WestCare Employee'
              options={activitiesRefernceData?.activityByList}
              errors={!!errors.activityByWestCareEmployee}
              helperText={errors?.activityByWestCareEmployee?.message}
            />
            <FormInputDropdown
              name='priority'
              control={control}
              label='Priority'
              options={activitiesRefernceData?.priorities}
              errors={!!errors.priority}
              helperText={errors?.priority?.message}
            />
            <FormInputDropdown
              name='Is12StepQuestionAsked'
              control={control}
              label='Is 12 Step Question Asked'
              options={stopYesNoOptions}
              yesNoDropDown={true}
              errors={!!errors.Is12StepQuestionAsked}
              helperText={errors?.Is12StepQuestionAsked?.message}
            />
            <FormInputDropdown
              name='Is12StepQuestionAnswered'
              control={control}
              label='Is 12 Step Question Answered'
              options={stopYesNoOptions}
              yesNoDropDown={true}
              errors={!!errors.Is12StepQuestionAnswered}
              helperText={errors?.Is12StepQuestionAnswered?.message}
              disabled={
                defaultValue.Is12StepQuestionAsked === false ? true : false
              }
            />
            <FormInputDropdown
              name='recdCBPROI'
              control={control}
              label='Recd CBP ROI'
              options={stopYesNoOptions}
              yesNoDropDown={true}
              errors={!!errors.recdCBPROI}
              helperText={errors?.recdCBPROI?.message}
            />
          </Grid>
          <Grid item xs={12}>
            <FormInputText
              name='activityNote'
              label='Note'
              control={control}
              multiline={true}
              shrink={true}
              rows={15}
              register={register('activityNote', {
                onBlur: (e) => {
                  //alert(e.target.value)
                  dispatch(setActivityNote(e.target.value))
                }
              })}
            />
          </Grid>  
          <ButtonWrapper>
            <CancelButton
              variant='contained'
              //disabled={_.isEmpty(dirtyFields) || !isValid}
              onClick={handleClose}
            >
              Cancel
            </CancelButton>
            {!activitiesInfo?.newActivity && (
                  <DeleteButton
                    variant="contained"
                    disabled={defaultValue.authIsLocked}
                    onClick={handleDelete}
                  >
                    Delete
                  </DeleteButton>
                )}
            <SaveButton
              variant='contained'
              //disabled={_.isEmpty(dirtyFields) || !isValid}
              onClick={handleSubmit(onSubmit)}
            >
              Save
            </SaveButton>
          </ButtonWrapper>
        </Grid>
      </Dialog>
      <FormSuccess
        formSuccess={formSuccess}
        setFormSuccess={setFormSuccess}
        isNewForm={isNewActivity}
      />
    </>
  );
};

export default ActivityDialog;
